<template>
    <div>
        <div class="mt-10" :class="view_class_view.div_container">
            <p v-show="texts.title_amount" class="label-input w-full" :class="view_class_view.label" v-html="texts.title_amount"></p>

            <money3 
                name="amount_coverage" 
                id="amount_coverage"
                v-model.lazy="coverageModel.amount"
                v-bind="config"
                :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: coverageModelValidations.amount.$error,
                [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]: coverageModelValidations.amount.$invalid,
                [view_class_view.class_inputs.default ]: !coverageModelValidations.amount.$invalid && !coverageModelValidations.amount.$error }"
                @blur="blurAmountDecimals($event); coverageModelValidations.amount.$validate"
                @focus="focusAmountDecimals"
                ></money3>
    
            <div :class="view_class_view.div_container_error.container" v-for="(error,index) of coverageModelValidations.amount.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div> 
        </div>

        <div class="label-input w-full">
            <p v-show="texts.title_coverage" class="mt-5" v-html="texts.title_coverage"></p>
            <ol class="coverage-list mt-5">
                <li v-for="(coverage, i) in coverage_list" :key="i" class="mb-4">
                    <label :class="view_class_view.label_input_checkbox">
                        <CheckBoxComponent :idCheckBox="'list_coverage_'+coverage.value" :cheked="coverage.active" @change-date-value="changeCheckBox($event, coverage.value)" :disabled="coverage.disabled"/>
                        <span :class="{'text-gray-400': coverage.disabled}">{{ coverage.text }}</span>
                        <span :class="coverage.information_class_view">{{ coverage.information_text }}</span>
                    </label>
                </li>
            </ol>
        </div>
        <div :class="view_class_view.div_container_error.container" v-for="(error,index) of coverageModelValidations.coverage.$errors" :key="index">
            <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
        </div> 
    </div>

</template>

<script>

import { ref, watch, toRef } from 'vue';
import useVuelidate from '@vuelidate/core';
import CheckBoxComponent from './../components/CheckBox';
import { Money3Component } from 'v-money3';

export default {
    props: {
        texts: {
            type: Object,
            default(){
                return {
                    title_amount: 'Indica la suma asegurada<br>Min $50,000.00 Max 2,000,000.00',
                    title_coverage: 'Selecciona si desea contratar algún beneficio adicional:',
                };
            }
        },
        validations:{
            type: Object,
            required: true,
            default(){
                return {};
            }
        },
        view_class_view:{
            type: Object,
            required: true,
            default(){
                return {};
            }
        },
        buttons_styles: {
            type: Object,
            required: true,
            default(){
                return {};
            }
        },
        coverage_list: {
            type: Array,
            required: true,
            default(){
                return [];
            }
        }
    },
    directive: {
        money3: Money3Component
    },
    setup(props) {
        let coverageList = toRef(props, 'coverage_list')
        let coverageModel  = ref({
            amount: "100,000.00",
            coverage: []
        });

        let coverageModelValidations = useVuelidate(props.validations, coverageModel);
        let config = {
            decimal: '.',
            thousands: ',',
            prefix: '$ ',
            precision: 2,
            masked: false
        };

        watch(coverageList, () => {
            checkPreselected(coverageList)
        })

        function checkPreselected(options){
            let optionsCheckedFilter = options.value.filter(element => element.active == true);
            optionsCheckedFilter = optionsCheckedFilter.map(element => element.value);
            
            if(optionsCheckedFilter.length<1)return;
            
            coverageModel.value.coverage = optionsCheckedFilter;
        }

        function getValueQuestioncoverage(value) {
            coverageModel.value.consumes = value;
        }

        function consumptionSelectLastDate(value){
            coverageModel.value.narcotics.last_consumption_date = value;
        }

        function changeCheckBox(status, id){
            if(status){
                coverageModel.value.coverage.push(id);
            }else{
                const index = coverageModel.value.coverage.indexOf(id);
                coverageModel.value.coverage.splice(index, 1)
            }
        }

        function execute_validation() {
            coverageModelValidations.value.$validate();
            if(coverageModelValidations.value.$error){
                return false;
            }
            return coverageModel.value;
        }
        function focusAmountDecimals(){
            coverageModel.value.amount = eliminarSignoDolarYCeros(coverageModel.value.amount)
            config.precision = 0;
        }
        function blurAmountDecimals(){
            coverageModel.value.amount = agregarPuntoYCeros(coverageModel.value.amount)
            config.precision = 2;
        }
        
        function eliminarSignoDolarYCeros(numero) {
            // Eliminar el signo
            numero = numero.replace('$', '');
            // Eliminar los dos últimos ceros después del punto decimal
            if (numero.includes('.')) {
                const partes = numero.split('.');
                if (partes[1].length >= 2) {
                partes[1] = partes[1].slice(0, -2);
                }
                numero = partes.join('.');
            }
            return numero;
        }
        function agregarPuntoYCeros(numero) {
            // Verificar si el número ya tiene un punto decimal
            if (numero.includes('.')) {
                const partes = numero.split('.');
                // Verificar si ya hay dos o más dígitos después del punto decimal
                if (partes[1].length >= 2) {
                    return numero; // El número ya tiene dos o más dígitos después del punto decimal
                }
                // Agregar los ceros faltantes después del punto decimal
                const cerosFaltantes = 2 - partes[1].length;
                numero = partes[0] + '.' + partes[1] + '0'.repeat(cerosFaltantes);
            } else {
                // El número no tiene punto decimal, agregarlo y los ceros
                numero += '.00';
            }
            
            return numero;
        }

        return {
            coverageModel,
            coverageModelValidations,
            config,
            getValueQuestioncoverage,
            consumptionSelectLastDate,
            changeCheckBox,
            execute_validation,
            focusAmountDecimals,
            blurAmountDecimals,
        };
    },
    components: {
        CheckBoxComponent,
        money3: Money3Component
    }
}
</script>

<style>
ol.coverage-list{
    display: grid;
}
.customCheckbox + label:before {
    margin-top: 0px!important;
}
.customCheckbox + label:after {
    margin-top: 0.5em!important;
}
</style>